import React from 'react';
import '../Details.css'; 
import './Data.css';
import { Link } from 'react-router-dom';
import Navbar from '../navbar';
import Chart from "react-apexcharts";
import DashboardTabs from './DashboardTabs';
import PerformanceTracking from './PerformanceTracking';
import MenuAndInventory from './MenuAndInventory';
import TableManagement from './TableManagement ';
import OrderManagement from './OrderManagement ';
import PeriodFilter from './PeriodFilter';
import UsageData from './UsageData ';
import ChartNavigationBar from './ChartNavigationBar';
import CustomerData from './CustomerData';
import { useEffect, useState,useRef } from 'react';

function Data({RestaurantID,browseDiningSessions}) {
const pageTitle = "Data"

  const items = [
    { key: "perf", label: "PERFORMANCE TRACKING", defaultChartCategory: "1", defaultChartId:"1", element: <PerformanceTracking />, buttonsList:[
       {categoryID: 1, chartID:1, title: "Sales", icon: "reports", chartType: "line"},
       {categoryID: 1, chartID:2, title: "Sales by Subcategory", icon: "reports", chartType: "line"},
        {categoryID: 2, chartID:4, title: "Sales by Item", icon: "reports", chartType: "line"},
      {categoryID: 1, chartID:4, title: "Top 10 Selling Items", icon: "reports", chartType: "table"},
         {categoryID: 1, chartID:5, title: "Visit/Service Time", icon: "reports", chartType: "bar"},
                     {categoryID: 1, chartID:6, title: "Total No. Of Guests", icon: "reports", chartType: "line"},
           {categoryID: 1, chartID:7, title: "Average time between order status updates", icon: "reports", chartType: "bar"},
          {categoryID: 1, chartID:8, title: "Average time taken to prepare order by Day Part Analysis", icon: "reports", chartType: "bar"},
          {title: "Day-End Financial Audit", icon: "reports", chartType: "link", linkTo: "data/day-end-audit"},
       
           
           ]},
    { key: "menu",     label: "MENU AND INVENTORY", defaultChartCategory: "2", defaultChartId:"1", element: <MenuAndInventory />,  buttonsList:[
            {categoryID: 2, chartID:1, title: "Menu Item Data", icon: "reports", chartType: "table"},
           {categoryID: 2, chartID:2, title: "Inventory Reports - Current Stock Levels", icon: "reports", chartType: "table"},
            {categoryID: 1, chartID:2, title: "Sales by Category", icon: "reports", chartType: "line"},
            {categoryID: 2, chartID:4, title: "Sales by Item", icon: "reports", chartType: "line"},
          ]},
    { key: "table",    label: "TABLE MANAGEMENT",   defaultChartCategory: "3", defaultChartId:"1", element: <TableManagement />, buttonsList:[
      {categoryID: 3, chartID:1, title: "Table Open/Close", icon: "reports", chartType: "pie"},      
       {categoryID: 3, chartID:2, title: "Average Visit Time", icon: "reports", chartType: "stats"},
            {categoryID: 3, chartID:2, title: "Total Gratuity", icon: "reports", chartType: "stats"},
            {categoryID: 3, chartID:2, title: "Total Abandonment Rate", icon: "reports", chartType: "stats"},
            
            {categoryID: 3, chartID:2, title: "Number of Guests By Party/Session", icon: "reports", chartType: "bar"},
           
      {categoryID: 3, chartID:6, title: "Total Sessions", icon: "visits", chartType: "stats"},
            {categoryID: 1, chartID:6, title: "Total Number of Guests", icon: "reports", chartType: "line"},
            {categoryID: 3, chartID:4, title: "Waiter Switching", icon: "reports", chartType: "bar"},
            {categoryID: 3, chartID:5, title: "Waiter Check-in Intervals", icon: "reports", chartType: "bar"},
            {categoryID: 3, chartID:6, title: "Table Admin Event", icon: "reports", chartType: "bar"},
            {categoryID: 1, chartID:5, title: "Visit/Service Time", icon: "reports", chartType: "bar"},
          ]},
    { key: "orders",   label: "ORDER MANAGEMENT",  defaultChartCategory: "4", defaultChartId:"1",   element: <OrderManagement />, buttonsList:[
            {categoryID: 4, chartID:1, title: "Average time taken to prepare an order by Day Part Analysis", icon: "reports", chartType: "bar"},
           {categoryID: 4, chartID:2, title: "Average time taken to prepare an order by Menu Category", icon: "reports", chartType: "bar"},
           {categoryID: 4, chartID:3, title: "Average time taken to prepare an order by Menu Subcategory", icon: "reports", chartType: "bar"},
           {categoryID: 4, chartID:4, title: "Average time taken to prepare an order by Menu Item", icon: "reports", chartType: "bar"},
           {categoryID: 4, chartID:5, title: "Average time taken between order status updates", icon: "reports", chartType: "bar"},
            {categoryID: 4, chartID:6, title: "Order Event Types", icon: "reports", chartType: "bar"},
          ] },
    { key: "usage",    label: "USAGE DATA",     defaultChartCategory: "5", defaultChartId:"1",      element: <UsageData />, buttonsList:[
            {categoryID: 5, chartID:1, title: "Number of Waiter Requests in a given period by restaurant - Day Part Analysis", icon: "reports", chartType: "line"},
           {categoryID: 5, chartID:2, title: "Number of Waiter Requests in a given period by waiter", icon: "reports", chartType: "bar"},
           {categoryID: 5, chartID:3, title: "Numbe of Manager Requests - Daypart Analysis", icon: "reports", chartType: "bar"},
           {categoryID: 5, chartID:4, title: "Number of Manager Requests by waiter", icon: "reports", chartType: "bar"},
           {categoryID: 5, chartID:5, title: "Average communication rate between waiters and customer during the dining experience by restaurant - Day Part Analysis", icon: "reports", chartType: "bar"},
            {categoryID: 5, chartID:6, title: "Average communication rate between waiters and customer during the dining experience by waiter", icon: "reports", chartType: "bar"},
          ]},
    { key: "customer", label: "CUSTOMER DATA",   defaultChartCategory: "6", defaultChartId:"0/1",     element: <CustomerData />, buttonsList:[
            {categoryID: 6, chartID:"0/1", title: "Host Introduction", icon: "reports", chartType: "rating_category"},
           {categoryID: 6, chartID:"1/1", title: "Food", icon: "reports", chartType: "rating_category"},
           {categoryID: 6, chartID:"2/1", title: "Atmosphere", icon: "reports", chartType: "rating_category"},
           {categoryID: 6, chartID:"3/1", title: "Service", icon: "reports", chartType: "rating_category"},
           {categoryID: 6, chartID:"4/1", title: "Table Mate Experience", icon: "reports", chartType: "rating_category"},
            {sessionID: 1, title: "Browse Individual Dining Sessions", icon: "reports", chartType: "link", linkTo:"data/browse/dining"},
            {categoryID: 6, chartID:0, title: "Manage/Update Questions", icon: "reports", chartType: "link", linkTo: "settings/questions"},
          ] },
  ];

  return (
    <div className="details-container-page data-page">
      <Navbar pageTitle={pageTitle} onToggleSidebar={true} />
      <div className="content">
        <DashboardTabs items={items} RestaurantID={RestaurantID} browseDiningSessions={browseDiningSessions}/>
        </div>
    </div>
  );
}

export default Data;
